export enum FileTypeEnum {
    PDF,
    XLS,
    XLSX,
    DOC,
    DOCX,
}
